<template>
  <div class="stages-experts-avatar" @click="$emit('click')" :index="index">
    <img class="circle" :src="`${PUBLIC_PATH}images/${expert[index]}`">
    <p>
      <slot></slot>
    </p>
  </div>
</template>

<script>
  export default {
    name: "StagesExpertsAvatar",
    props: {
      index: {
        default: null,
      }
    },
    data() {
      return {
        PUBLIC_PATH: process.env.VUE_APP_ASSETS_PATH,
        expert: [
          `przemek_expert.png`,
          `szczuka_expert.png`,
          `karol_expert.png`,
          `marcin_expert.png`,
        ],
      }
    }

  }
</script>

<style lang="scss" scoped>

  .stages-experts-avatar {
    display: flex;
    align-items: center;
    cursor: pointer;

    p {
      padding-left: 20px;
      min-width: 170px;
    }

    $circle-size: 50px;

    .circle {
      width: $circle-size;
      height: $circle-size;
      border-radius: 50%;
      background-color: $color-rwl-gray-15;
      background-image: url('/images/R-sign.png');
    }

    @media (min-width: $breakpoint-sm-min) {

      p {
        padding: 5px;
        min-width: initial;
      }

      .circle {
        width: 60px;
        height: 60px;
      }
    }

    @media (min-width: $breakpoint-md-min) {
      p {
        padding-left: 15px;
      }

      .circle {
        width: 75px;
        height: 75px;
      }
    }
  }


</style>
